export default {
  'dashboard.summary': 'Resumen',
  'dashboard.dashboard': 'Dashboard',
  'dashboard.business': 'Negocios',
  'dashboard.advertisements': 'Anuncios',
  'dashboard.name': 'Nombre',
  'dashboard.sector': 'Sector',
  'dashboard.amount-advertisements': 'Nº Anuncios',
  'dashboard.advertisements-states': 'Estado anuncios',
  'dashboard.investment': 'Inversión',
  'dashboard.state': 'Estado',
};
